import React from 'react';
import MobileAppV2Container from '@src/containers/MobileAppV2';

const MobileApp = () => <MobileAppV2Container />;

export default MobileApp;
